import { Box, CircularProgress } from '@mui/material'
import { FC } from 'react'

export const Loader: FC = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <CircularProgress size={60} sx={{ m: 4 }} />
  </Box>
)
